import { TaskType, MonthEventType } from '@/models/enums';
import moment from 'moment';
import { DateFormat } from '@/plugins/date-filter';

export class CalendarHelper {
    public mapDefect(defect: any, dateMap: any) {
        let theDate = defect.scheduledDate;
        if (!this.isInMonth(theDate) || this.isInThePast(theDate)) {
            return;
        }
        dateMap[theDate] = dateMap[theDate] || {};
        this.pushEvent(defect, dateMap[theDate], MonthEventType.Defect);
    }
    public mapCampaign(campaignUnit: any, dateMap: any) {
        if (!this.isInMonth(campaignUnit.scheduledDate)) {
            return;
        }
        dateMap[campaignUnit.scheduledDate] = dateMap[campaignUnit.scheduledDate] || {};
        this.pushEvent(campaignUnit, dateMap[campaignUnit.scheduledDate], MonthEventType.Campaign);
    }
    public mapCompletedDefect(notice: any, dateMap: any) {
        if (!this.isInMonth(notice.completedDate)) {
            return;
        }
        dateMap[notice.completedDate] = dateMap[notice.completedDate] || {};
        this.pushEvent(notice.completedCount, dateMap[notice.completedDate], MonthEventType.CompletedDefects);
    }
    public mapService(service: any, dateMap: any) {
        dateMap[service.date] = dateMap[service.date] || {};
        service.tasks.forEach((e: any) => this.mapServiceTask(e, dateMap[service.date]));
    }
    public mapServiceTask(task: any, eventsMap: any) {
        if (task.type === TaskType.PreventativeMaintenance) {
            this.pushEvent(task, eventsMap, MonthEventType.PreventativeMaintenance);
        } else if (task.type === TaskType.MajorService) {
            this.pushEvent(task, eventsMap, MonthEventType.MajorService);
        } else if (task.type === TaskType.Brakes) {
            this.pushEvent(task, eventsMap, MonthEventType.BrakeCheck);
        } else if (task.type === TaskType.ContainerInspection) {
            this.pushEvent(task, eventsMap, MonthEventType.ContainerInspection);
        }
    }
    public mapDateBasedTask(task: any, dateMap: any) {
        this.mapWarning(task, dateMap);
        this.mapDue(task, dateMap);
    }
    public mapWarning(task: any, dateMap: any) {
        if (!this.isInMonth(task.warningDate)) {
            return;
        }
        dateMap[task.warningDate] = dateMap[task.warningDate] || {};
        this.pushEvent(task, dateMap[task.warningDate], MonthEventType.DateBasedTask);
    }
    public mapDue(task: any, dateMap: any) {
        if (!this.isInMonth(task.displayDate)) {
            return;
        }
        dateMap[task.displayDate] = dateMap[task.displayDate] || {};
        this.pushEvent(task, dateMap[task.displayDate], MonthEventType.DateBasedTask);
    }
    public mapBrakeCheck(brakeCheck: any, dateMap: any) {
        if (!this.isInMonth(brakeCheck.date) || brakeCheck.isComplete) {
            return;
        }
        dateMap[brakeCheck.date] = dateMap[brakeCheck.date] || {};
        this.pushEvent(brakeCheck.brakeCheck, dateMap[brakeCheck.date], MonthEventType.BrakeCheck);
    }
    public pushEvent(task: any, eventsMap: any, type: any) {
        eventsMap[type] = eventsMap[type] || [];
        eventsMap[type].push(task);
    }
    public isInMonth(date: Date | string | number) {
        return moment(date).isBetween(this.from(date), this.to(date), 'day', '[]');
    }
    public isInThePast(date: Date | string | number) {
        return moment(date).isBefore(moment().subtract(1, 'day'));
    }
    public from(date: Date | string | number) {
        return moment(date)
            .startOf('month')
            .subtract(6, 'days')
            .format(DateFormat.Canonical);
    }
    public to(date: Date | string | number) {
        return moment(date)
            .endOf('month')
            .add(6, 'days')
            .format(DateFormat.Canonical);
    }
}

export default new CalendarHelper();
